// extracted by css-extract-rspack-plugin
export default {"colorCircle":"AutocompleteTokenTagInput-module__colorCircle__byARA","wrapper":"AutocompleteTokenTagInput-module__wrapper__pRYxn"};